import { render, staticRenderFns } from "./DropdownSlider.vue?vue&type=template&id=15f036bb&scoped=true&"
import script from "./DropdownSlider.vue?vue&type=script&lang=js&"
export * from "./DropdownSlider.vue?vue&type=script&lang=js&"
import style0 from "./DropdownSlider.vue?vue&type=style&index=0&id=15f036bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f036bb",
  null
  
)

export default component.exports